/**
 * How many tickets each Team has Working, for the rail's Team rows.
 *
 * Derived from the list the queues load (`useWorkFeed`, `GET /api/work-items`),
 * never a second read: the feed publishes `workingByTeam` (`teams/allTeams.ts`,
 * the Team queue's own grouping) whenever it lands, and the rail reads it, so
 * the rail's number is the number the Team page prints beside Working.
 * `/api/desks` does not carry a working count, so between feed reads the rail
 * keeps the last one it heard.
 */
import { useSyncExternalStore } from "react";

/** Team id to its Working count; a Team with none is absent. */
export type TeamWorkingMap = ReadonlyMap<string, number>;

let working: TeamWorkingMap = new Map();
const listeners = new Set<() => void>();

function sameCounts(a: TeamWorkingMap, b: TeamWorkingMap): boolean {
  if (a.size !== b.size) return false;
  for (const [id, n] of a) if (b.get(id) !== n) return false;
  return true;
}

export function publishTeamWorking(next: TeamWorkingMap): void {
  if (sameCounts(next, working)) return;
  working = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useTeamWorking(): TeamWorkingMap {
  return useSyncExternalStore(
    subscribe,
    () => working,
    () => working,
  );
}

/** Test-only. */
export function __resetLiveTeamsForTests(): void {
  working = new Map();
  listeners.clear();
}
